import React, { useState, useEffect, useRef } from 'react';
import './TableOfContents.css';

function TableOfContents({ headings }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth > 1200) {
        setIsExpanded(false);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && isExpanded && navRef.current && !navRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    if (isMobile && isExpanded) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isMobile, isExpanded]);

  if (!headings || headings.length === 0) {
    return null;
  }

  const handleClick = (e, id) => {
    e.preventDefault();
    
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        // Find the scrollable container (page-container)
        const scrollContainer = document.querySelector('.page-container');
        if (scrollContainer) {
          // Get current scroll position
          const currentScrollTop = scrollContainer.scrollTop;
          // Get element position relative to viewport
          const elementRect = element.getBoundingClientRect();
          // Get container position relative to viewport
          const containerRect = scrollContainer.getBoundingClientRect();
          // Calculate element position relative to container
          const elementTopRelativeToContainer = elementRect.top - containerRect.top + currentScrollTop;
          const offset = 150; // Offset for fixed header/navigation
          
          scrollContainer.scrollTo({
            top: elementTopRelativeToContainer - offset,
            behavior: 'smooth'
          });
        } else {
          // Fallback to window scroll if container not found
          const offset = 150;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
        
        // Close mobile menu after clicking
        if (isMobile) {
          setIsExpanded(false);
        }
      } else {
        console.warn(`Element with id "${id}" not found`);
      }
    }, 10);
  };

  const handleToggle = (e) => {
    if (isMobile) {
      e.preventDefault();
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <nav 
      ref={navRef}
      className={`table-of-contents ${isExpanded ? 'expanded' : ''}`}
      onClick={isMobile && !isExpanded ? handleToggle : undefined}
    >
      <ul className="toc-list">
        {headings.map((heading, index) => (
          <li 
            key={index} 
            className={`toc-item toc-level-${heading.depth}`}
          >
            <a 
              href={`#${heading.id}`}
              onClick={(e) => handleClick(e, heading.id)}
              className="toc-link"
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default TableOfContents;
